import { Injectable } from '@angular/core';
import { PresupuestoServiceInterface, SegPresupuestalFactory } from './seg-presupuestal-factory';
import { Observable } from 'rxjs';
import { cuentaEntity, detalleCuentaEntity, detalleIndicadorEntity, evaluacionesAllEntity, evaluacionesEntity, gruposIndEntity, indicadorEntity, modIndEntity, sucursalesEntity, varTipoEntity } from './Manual/entities';

@Injectable({
  providedIn: 'root'
})
export class SegPresupuestalService {
  private impl: PresupuestoServiceInterface;

  constructor(
    private factory: SegPresupuestalFactory,
  ) { 
    this.impl = this.factory.getService();
  }

  /**
   * 
   * @param params evaluacionesEntity
   * @returns 
   */
  getPeriodos(params: evaluacionesEntity): Observable<any>{
    return this.impl.getPeriodos(params);
  }
  /**
   * 
   * @param params evaluacionesEntity
   * @returns 
   */
  getPeriodosAll(params: evaluacionesAllEntity): Observable<any>{
    return this.impl.getPeriodosAll(params);
  }
  /**
   * 
   * @param params sucursalEntity
   * @returns 
   */
  getSucursales(params: sucursalesEntity): Observable<any>{
    return this.impl.getSucursales(params);
  }
  /**
   * 
   * @param params cuenta entity 
   * @returns 
   */
  getCuentasDescripcion(params: cuentaEntity): Observable<any>{
    return this.impl.getCuentasDescripcion(params);
  }
  /**
   * 
   * @param params cuenta entity 
   * @returns 
   */
  getCuentasValor(params: detalleCuentaEntity): Observable<any>{
    return this.impl.getCuentasValor(params);
  }
  /**
   * 
   * @param params modulos de indicadores entity 
   * @returns 
   */
  getModuloIndicador(params: modIndEntity): Observable<any>{
    return this.impl.getModuloIndicador(params);
  }
  /**
   * 
   * @param params grupos de indicadores entity 
   * @returns 
   */
  getgrupoInd(params: gruposIndEntity): Observable<any>{
    return this.impl.getgrupoInd(params);
  }
  /**
   * 
   * @param params indicadores entity 
   * @returns 
   */
  getIndicadoresPropiedades(params: indicadorEntity): Observable<any>{
    return this.impl.getIndicadoresPropiedades(params);
  }
  /**
   * 
   * @param params indicadores entity 
   * @returns 
   */
  getIndicadoresDescripcion(params: indicadorEntity): Observable<any>{
    return this.impl.getIndicadoresDescripcion(params);
  }
  /**
   * 
   * @param params detalle indicadores entity 
   * @returns 
   */
  getIndicadoresValor(params: detalleIndicadorEntity): Observable<any>{
    return this.impl.getIndicadoresValor(params);
  }
  /**
   * 
   * @param params grupos de indicadores entity 
   * @returns 
   */
  getindicadorGrupo(grupoIndicador: number): Observable<any>{
    return this.impl.getindicadorGrupo(grupoIndicador);
  }
  getVariableTipoDescripcion(params: varTipoEntity){
    return this.impl.getVariableTipoDescripcion(params);
  }
  getVariableTipoValor(params: varTipoEntity){
    return this.impl.getVariableTipoValor(params);
  }
}
